<dx-popup
    [showTitle]="true"
    title="Settings"
    [dragEnabled]="false"
    [hideOnOutsideClick]="true"
    [showCloseButton]="false"
    [visible]="visible"
    [toolbarItems]="toolbarItems"
    [maxWidth]="500"
    [height]="'auto'"
>   
    <dx-form 
        [formData]="formData"
        (onFieldDataChanged)="onFormChanged($event)"
        >
        <dxi-item
            dataField="machineName"
            editorType="dxSelectBox"
            [isRequired]="true"
            [editorOptions]="{
                dataSource: machineOptions,
                displayExpr: 'name',
                valueExpr: 'name',
                placeholder: 'Select machine'
            }">
        </dxi-item>

        <dxi-item
            dataField="sectionIndex"
            editorType="dxSelectBox"
            [isRequired]="true"
            [editorOptions]="{
                dataSource: sectionOptions,
                displayExpr: 'name',
                valueExpr: 'index',
                placeholder: 'Select section'
            }">
        </dxi-item>
    </dx-form>
</dx-popup>